<script setup>
import {ref, onMounted, defineProps, defineEmits} from 'vue';
import {Modal} from 'bootstrap';

const props = defineProps({
    title: {
        type: String,
        default: 'Confirmation'
    },
    modalDialogClass: {
        type: String,
        default: ''
    },
    confirmButtonText: {
        type: String,
        default: 'Confirmer'
    },
    cancelButtonText: {
        type: String,
        default: 'Annuler'
    },
    anotherButtonText: {
        type: String,
        default: ''
    },
    confirmButtonClass: {
        type: String,
        default: 'btn-primary'
    },
    cancelButtonClass: {
        type: String,
        default: 'btn-secondary'
    },
    anotherButtonClass: {
        type: String,
        default: 'btn-secondary'
    }
});

const emit = defineEmits(['confirm', 'cancel', 'another']);

const modalRef = ref(null);
let bsModal = null;

onMounted(() => {
    if (modalRef.value) {
        bsModal = new Modal(modalRef.value);

        // Add event listener for when modal is hidden
        modalRef.value.addEventListener('hidden.bs.modal', () => {
            emit('cancel');
        });
    }
});

const show = () => {
    if (bsModal) {
        bsModal.show();
    }
};

const hide = () => {
    if (bsModal) {
        bsModal.hide();
    }
};

const handleConfirm = () => {
    emit('confirm');
    hide();
};

const handleCancel = () => {
    emit('cancel');
    hide();
};

const handleAnother = () => {
    emit('another');
    hide();
};

// Expose methods to parent components
defineExpose({
    show,
    hide
});
</script>

<template>
    <div class="modal fade"  ref="modalRef" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog" :class="modalDialogClass">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ title }}</h5>
                    <button type="button" class="btn-close" @click="handleCancel" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <!-- Slot for custom content -->
                    <slot></slot>
                </div>
                <div class="modal-footer">
                    <button type="button" :class="['btn', cancelButtonClass]" @click="handleCancel">
                        {{ cancelButtonText }}
                    </button>
                    <button v-if="anotherButtonText" type="button" :class="['btn', anotherButtonClass]" @click="handleAnother">
                        {{ anotherButtonText }}
                    </button>
                    <button type="button" :class="['btn', confirmButtonClass]" @click="handleConfirm">
                        {{ confirmButtonText }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
/* Add any custom styles here */
</style>
